<template>
  <div>
    <label class="d-block">
      {{ $t(`commands.panels.${config.label}`) }}
    </label>
    <validation-provider
      :name="config.label"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        label="name"
        :options="actions"
        v-model="model"
        :clearable="false"
        :reduce="(val) => val.name"
        input-id="action-id"
        :multiple="multiple"
        @input="$emit('input', model)"
      />
      <!-- <p class="mb-0 small">{{ config.label }}</p> -->
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {EventBus} from "@/libs/event-bus";
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: null,
      actions: []
    };
  },
  created() {
    this.model = this.value;
  },
  mounted() {
    EventBus.on('actions-selected', (actions) => this.actions = actions);
  },
  beforeDestroy() {
    EventBus.off('actions-selected', (actions) => this.actions = actions);
  }
};
</script>

<style></style>
